export const browserIsolationLicense = 'BROWSER_ISOLATION';
export const emailIsolationLicense = 'EMAIL_ISOLATION';
export const saasIsolationLicense = 'SAAS_ISOLATION';
export const emailAndSaasIsolationLicense = 'EMAIL_AND_SAAS_ISOLATION';
export const tapIsolationLicense = 'TAP_ISOLATION';
export const tapAndSaaSIsolationLicense = 'TAP_AND_SAAS_ISOLATION';

export const ALL_LICENSES = [
    browserIsolationLicense,
    emailIsolationLicense,
    saasIsolationLicense,
    emailAndSaasIsolationLicense,
    tapIsolationLicense,
    tapAndSaaSIsolationLicense,
];
